import { useLayoutEffect } from 'react'
import { autoUpdate, computePosition, flip, offset, shift } from '@floating-ui/dom'

// Keeps `floatingRef` positioned next to the reference returned by
// `getReference` (an element or a virtual element with getBoundingClientRect).
const useFloatingPosition = (floatingRef, getReference, { open, placement = 'bottom-start', gap = 6 }, deps) => {
  useLayoutEffect(() => {
    const floating = floatingRef.current
    const reference = open && getReference()
    if (!floating || !reference) {
      return
    }
    const update = () => {
      computePosition(reference, floating, {
        placement,
        strategy: 'fixed',
        middleware: [offset(gap), flip(), shift({ padding: 8 })]
      }).then(({ x, y }) => {
        floating.style.left = `${x}px`
        floating.style.top = `${y}px`
      })
    }
    return autoUpdate(reference, floating, update)
  }, [open, ...deps]) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useFloatingPosition
